import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Hero() {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="hero">
      <div className="container">
        <div className="hero-content">
          <h1>
            {t('hero.title')}<br />
            <span>{t('hero.titleHighlight')}</span>
          </h1>
          <p>{t('hero.subtitle')}</p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => scrollTo('solutions')}>
              {t('hero.cta')}
            </button>
            <button className="btn-secondary" onClick={() => scrollTo('contact')}>
              {t('hero.ctaSecondary')}
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-graphic">
            <div className="hero-graphic-inner">
              <img src="/logo.png" alt="ScanEat" className="hero-logo" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
